var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _vm._l(_vm.assessPlan.processes, function (process, idx) {
            return _c(
              "q-chip",
              {
                key: idx,
                attrs: {
                  outline: "",
                  square: "",
                  removable:
                    _vm.editable &&
                    !_vm.disabled &&
                    process.ramProcessAssessStepCd !== "RPA0000005",
                  color: process.selected ? "primary" : "grey-6",
                  "text-color": "white",
                  icon: "memory",
                  selected: process.selected,
                  label: process.processName,
                  title: process.processName,
                },
                on: {
                  "update:selected": [
                    function ($event) {
                      return _vm.$set(process, "selected", $event)
                    },
                    (state) => _vm.selectedProcess(state, process, idx),
                  ],
                  remove: (state) => _vm.removeProcess(state, process),
                },
                model: {
                  value: process.check,
                  callback: function ($$v) {
                    _vm.$set(process, "check", $$v)
                  },
                  expression: "process.check",
                },
              },
              [_c("q-tooltip", [_vm._v(_vm._s(process.processName))])],
              1
            )
          }),
          _vm.editable && !_vm.disabled
            ? _c("q-chip", {
                attrs: {
                  outline: "",
                  square: "",
                  clickable: "",
                  color: "orange",
                  "text-color": "white",
                  icon: "add",
                  label: "직접추가",
                  title: "직접추가",
                },
                on: { click: _vm.writeProcess },
              })
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("c-tab", {
            attrs: {
              type: "tabcard",
              align: "left",
              tabItems: _vm.tabItems,
              inlineLabel: true,
            },
            on: {
              "update:tabItems": function ($event) {
                _vm.tabItems = $event
              },
              "update:tab-items": function ($event) {
                _vm.tabItems = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (tab) {
                  return [
                    _c(tab.component, {
                      tag: "component",
                      attrs: {
                        process: _vm.process,
                        disabled: _vm.disabled,
                        updateBtnData: _vm.updateBtnData,
                      },
                      on: {
                        "update:process": function ($event) {
                          _vm.process = $event
                        },
                        "update:disabled": function ($event) {
                          _vm.disabled = $event
                        },
                        "update:updateBtnData": function ($event) {
                          _vm.updateBtnData = $event
                        },
                        "update:update-btn-data": function ($event) {
                          _vm.updateBtnData = $event
                        },
                        saveProcess: _vm.saveProcess,
                      },
                    }),
                  ]
                },
              },
            ]),
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          }),
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { persistent: "" },
          model: {
            value: _vm.processDialog.show,
            callback: function ($$v) {
              _vm.$set(_vm.processDialog, "show", $$v)
            },
            expression: "processDialog.show",
          },
        },
        [
          _c(
            "q-card",
            { staticStyle: { "min-width": "350px" } },
            [
              _c(
                "q-form",
                { ref: "editForm" },
                [
                  _c(
                    "c-card",
                    {
                      staticClass: "cardClassDetailForm",
                      attrs: { title: "평가대상 상세" },
                    },
                    [
                      _c(
                        "template",
                        { slot: "card-button" },
                        [
                          _c(
                            "q-btn-group",
                            { attrs: { outline: "" } },
                            [
                              _c("c-btn", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.editable && !_vm.disabled,
                                    expression: "editable&&!disabled",
                                  },
                                ],
                                attrs: { label: "저장", icon: "save" },
                                on: { btnClicked: _vm.saveWriteProcess },
                              }),
                              _c("c-btn", {
                                attrs: { label: "닫기", icon: "cancel" },
                                on: { btnClicked: _vm.closeDialog },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("template", { slot: "card-detail" }, [
                        _c(
                          "div",
                          { staticClass: "col-12" },
                          [
                            _c("c-text", {
                              attrs: {
                                editable: _vm.editable,
                                disabled: _vm.disabled,
                                label: "공정",
                                name: "processName",
                              },
                              model: {
                                value: _vm.processDialog.processName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.processDialog,
                                    "processName",
                                    $$v
                                  )
                                },
                                expression: "processDialog.processName",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }